module.exports = __webpack_public_path__ + "static/img/050503.a9811381.png";